    <!-- The AG Grid component -->
    <ag-grid-angular
        [rowData]="(measureTableData$ | async) || null"
        [columnDefs]="colDefs" 
        class="ag-theme-quartz shadow-md"
        domLayout="autoHeight"
        [suppressCellFocus]="true"
        [suppressMovableColumns]="true"
        [pagination]="pagination"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector] = "paginationPageSizeSelector"
        [defaultColDef]="defaultColDef"
        style="width: 100%; height: 100%"
        [components]="frameWorkComponents"
        />
